module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Media/Music-cloud-395280bc746b94ded80942c135aaa141.svg";